import TonWeb from 'tonweb';
import z from 'zod';

export const zTonAddressInput = z.string().refine(
  (value) => {
    try {
      return TonWeb.utils.Address.isValid(value);
    } catch {
      return false;
    }
  },
  {
    message: 'Please enter a valid address',
  },
);
